import React from "react";
import styled from "styled-components";
import { withI18n } from "react-i18next";
// @ts-ignore
import { CWBModal } from "cwb-react";

// @ts-ignore
import { CWBLoadingCrest } from "cwb-react";
import imageSrc from "../../images/icon-cwb-logo-grey.svg";

const SendLoadingModal = ({
  className,
  message,
  onConfirm,
  onCancel,
  buttons,
  show,
  sessionTemplateInfoSheet,
  sentCount,
  t,
}: any) => (
  <StyledModal
    className={`${className} cwb-modal`}
    title={t(`Sending Info Sheet to talent`)}
    body={message}
    hideModal={onCancel}
    isOpen={show}
  >
    <CWBLoadingCrest customLogoSrc={imageSrc} />
  </StyledModal>
);

const StyledModal = styled(CWBModal)`
  width: 100%;
  max-width: 600px !important;
  margin: 0 auto;

  &.create-role-modal {
    max-width: 450px;

    .modal-buttons {
      justify-content: space-around !important;
    }
  }

  .modal-dropdown {
    min-width: 200px;
    max-width: 200px;
    .cwb-dropdown__menu {
      .cwb-dropdown__option {
        min-width: 185px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }

  .close-modal {
    display: none !important;
  }

  .modal-content {
    width: 100%;
  }

  .modal-body {
    margin-bottom: 0px;
    padding-bottom: 0px;
    text-align: left !important;
  }

  .modal-buttons {
    justify-content: space-between !important;
  }

  .close-modal {
    right: 20px;

    &:before {
      color: #8395a7;
      font-size: 16px;
    }
  }

  .cwb-dropdown-wrapper {
    .cwb-dropdown__menu-list {
      text-align: left;
    }
  }
`;

export default withI18n()(SendLoadingModal);
